export const DEFAULT_PURPOSE = 44
const GENERIC_PURPOSES = [DEFAULT_PURPOSE]
const BITCOIN_PURPOSES = [49, 84, 86]
const CARDANO_SHELLEY_PURPOSE = [1852]
export const BIP32_PURPOSES = [...GENERIC_PURPOSES, ...BITCOIN_PURPOSES, ...CARDANO_SHELLEY_PURPOSE]

export const DEFAULT_CHAIN_INDEX = 0
export const DEFAULT_ADDRESS_INDEX = 0
